<template>
    <div style="height: 100%" ref="webix-container"></div>
</template>

<script>
    import {client as http, apiUrl} from "../../../http_client";
    import {mapGetters} from "vuex";
    import uuid from "uuid";

    let url = '';

    // mock data

    let calendars = [
        {"text": "Personal", "color": "#997CEB", "active": 1, "id": "1"},
        {"text": "Public", "color": "#01C2A5", "active": 1, "id": "2"},
        {"text": "Birthdays", "color": "#D2FB9E", "active": 0, "id": "3"},
        {"text": "Holidays", "color": "#F68896", "active": 0, "id": "4"},
    ];

    let events = [
        {
            "start_date": "2023-02-02 17:00:00", "end_date": "2023-02-02 20:00:00",
            "text": " Sample Session", "details": " Leipzig, GER ",
            section: 1,
            "color": "#91E4A6", "calendar": 2, "id": "1"
        },

        {
            "start_date": "2023-02-02 17:00:00", "end_date": "2023-02-02 20:00:00",
            "text": " Sample Session 2", "details": " Leipzig, GER ",
            section: 1,
            "color": "#91E4A6", "calendar": 2, "id": "2"
        },
    ];

    class customBackend extends scheduler.services.Backend {
        calendars() {
            return webix.promise.resolve((() => {
                return http.get(url + 'calendars').then(response => {
                    return response.data;
                });
            })());
            // return webix.promise.resolve(calendars);
        }

        addCalendar() {
            return webix.promise.resolve();
        }
        updateCalendar() {
            return webix.promise.resolve();
        }

        removeCalendar() {
            return webix.promise.resolve();
        }

        events() {
            return webix.promise.resolve((() => {
                return http.get(url + 'events').then(response => {
                    return response.data;
                });
            })());
            // return webix.promise.resolve(events);
        }

        sections() {
            // console.log('section', url);
            // return webix.promise.resolve([
            //     {"text": "Section 1", "id": "1"},
            //     {"text": "Section 2", "id": "2"},
            // ]);
            return webix.promise.resolve((() => {
                return http.get(url + 'sections').then(response => {
                    return response.data;
                });
            })());
        }

        addEvent() {
            return webix.promise.resolve(uuid.v4());
        }

        updateEvent() {
            return webix.promise.resolve();
        }

        removeEvent() {
            return webix.promise.resolve();
        }



    }

    class CustomBarsView extends scheduler.views["bars/nav"] {
        config() {
            const ui = super.config();

            ui.options = [
                {id: "timeline", value: "Timeline"}
            ];
            return ui;
        }
    }

    class CustomNavPopupView extends scheduler.views["bars/navpopup"] {
        config() {
            const ui = super.config();

            ui.body.body.rows[0].data = [
                {id: "timeline", value: "Timeline", icon: "shi-week"}
            ];
            return ui;
        }
    }

    export default {
        name: "WebixScheduler",
        props: ['conf'],
        data: function() {
            return {};
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {},
        mounted() {
            this.webixId = webix.ui({
                container: this.$el,
                $scope: this,
                view: "scheduler",

                // config
                date: new Date(this.conf.start_at),
                mode: 'timeline',
                // height: 1000,
                serverUTC: true,
                // borderless: true,
                calendars: true,
                dragCreate: false,
                // readonly: false,
                timeline: true,
                timelineMode: 'day',
                override: new Map([
                    [scheduler.services.Backend, customBackend],
                    // [scheduler.views["bars/nav"], CustomBarsView],
                    // [scheduler.views["bars/navpopup"], CustomNavPopupView]
                ]),
            });

            window.addEventListener('resize', () => {
                webix.$$(this.webixId).resize();
            });

            url = 'conferences/' + this.conf.id + '/scheduler/';
        },
        destroyed: function() {
            webix.$$(this.webixId).destructor();
        }
    };
</script>

<style lang="scss">

</style>
